import { string } from 'prop-types';

const documentTypeBasicInformationPropTypes = {
  name: string.isRequired,
  description: string.isRequired,
};

export default documentTypeBasicInformationPropTypes;
